// extracted by mini-css-extract-plugin
export default {"container":"Ak4GI_container"};